import {
    COD_CRISIS,
    COD_COMUNICATE,
    COD_APRENDER,
    COD_SOCIOEMOCIONAL,
    COD_FICHA_UNICA
} from "../../../helper.js";
import { FORM_DICTIONARY } from "./formFields";

const condicionalesDetalleCognitiva = () =>
    Object.values(FORM_DICTIONARY.fichas.cognitiva)
        .filter((campo) => campo?.name && campo?.detalle)
        .map((campo) => ({
            key: campo.detalle,
            label: `¿Cuál? / Tiempo (${campo.label})`,
            condition: (data) => data?.[campo.name]?.valor === 'SI',
        }));


/* =====================================================
    CAMPOS GENERALES
===================================================== */

export const CAMPOS_GENERALES = [
    "programa",
    "semestre",
    "fecha_nacimiento",
    "edad",
    "estado_civil",
    "sexo_biologico",
    "identidad_genero",
    "orientacion_sexual",
    "direccion_actual",
    "barrio",
    "lugar_procedencia",
    "departamento",
    "municipio",
    "correo_electronico",
    "celular",

    "contacto_emergencia",
    "celular_contacto_emergencia",
    "parentesco",

    "nombre_eps",
    "sisben",
    "no_vinculado",

    "grupo_priorizado",
    "se_auto_reconoce_grupo_priorizado",
    "certificado_grupo_priorizado",
];


/* =====================================================
    CONFIGURACIÓN DE SESIONES POR TIPO
===================================================== */

export const CONFIG_SESIONES = {
    [COD_COMUNICATE]: 5,
    [COD_APRENDER]: 8,
    [COD_SOCIOEMOCIONAL]: 8,
    [COD_CRISIS]: 0,
    [COD_FICHA_UNICA]: 0,
};


/* =====================================================
    GENERADOR DE SESIONES
===================================================== */

export const generarSesiones = (cantidad) => {
    if (!cantidad) return [];

    return Array.from({ length: cantidad }, (_, i) => ({
        numero: i + 1,
        asistencia: false,
        encuesta: false,
        reporte: false,
        nivel_riesgo: "",
        consentimiento: i === 0 ? false : undefined
    }));
};


/* =====================================================
    SEGUIMIENTOS SOLO PARA CRISIS
===================================================== */

const CAMPOS_SEGUIMIENTO_CRISIS = Array.from(
    { length: 6 },
    (_, i) => `seguimiento_${i + 1}`
);


/* =====================================================
    CAMPOS ESPECÍFICOS POR TIPO
===================================================== */

export const CAMPOS_ESPECIFICOS = {

    /* ================= CRISIS ================= */

    [COD_CRISIS]: [
        "ideacion_suicida",
        "conducta_suicida",
        "intento_suicida",

        "deseo_muerte",
        "deseo_danarse",
        "plan_suicida",
        "trataste_suicidarte",

        "toma_medicamentos",
        "nombre_medicamentos",
        "diagnostico_previo",
        "diagnostico",

        "descripcion_crisis",
        "motivo_crisis",
        "resumen_procedimiento",
        "recomendaciones",
        "nivel_riesgo",

        ...CAMPOS_SEGUIMIENTO_CRISIS
    ],


    /* ================= COMUNICATE ================= */

    [COD_COMUNICATE]: [
        "motivo_asesoria_comunicativa",
        "remitido_por",
        "diagnostico_comunicativo",
        "examenes_adjuntos",

        "antecedentes_comunicativos_detalle",
        "antecedentes_familiares_comunicativos",
        "con_quien_vive",
        "ocupacion_familia",
        "info_hermanos",
        "comunicacion_familiar",
        "actividades_tiempo_libre",

        "habcom_leer",
        "habcom_escribir",
        "habcom_escuchar",
        "habcom_hablar",

        "personas_entienden_comunicacion",
        "pryeccion_voz_adecuada",
        "muletillas",
        "habla_rapido",
        "habla_lento",

        "necesidad_escribir_leer",
        "necesidad_comunicacion",
        "necesidad_recepcion_informacion",

        "desempeno_academico",
        "desempeno_academico_influenciado",

        "hab_Inspeccionar",
        "hab_Preguntar",
        "hab_Leer",
        "hab_Escribir",
        "hab_Repasar",
        "hab_Otra"
    ],


    /* ================= APRENDER ================= */

    [COD_APRENDER]: [
        "motivo_consulta_cognitiva",
        "motivo_consulta_cognitiva_especifica",
        "informacion_personal_familiar",

        "problema_salud_especial",
        "problema_vision",
        "problema_audicion",
        "alteracion_sueno",
        "actualmente_esta_medicado",
        "antecedentes_neurologicos",
        "asistencia_terapia_neuropsicologica",

        "calificacion_desempeno_cognitivo",
        "influencia_desempeno",
        "asignaturas_modalidad_actual",
        "metodo_estudio_planificacion",
        "aspectos_revelantes_anotaciones",

        "detalle_problemas_salud",
        "detalle_problemas_vision",
        "detalle_problemas_audicion",
        "detalle_alteracion_sueno",
        "detalle_esta_medicado",
        "detalle_antecedentes_neurologicos",
        "detalle_terapia_neuropsicologia",
    ],


    /* ================= SOCIOEMOCIONAL ================= */

    [COD_SOCIOEMOCIONAL]: [
        "ideacion_suicida",
        "conducta_suicida",
        "intento_suicida",

        "deseo_muerte",
        "deseo_danarse",
        "plan_suicida",
        "trataste_suicidarte",

        "toma_medicamentos",
        "nombre_medicamentos",
        "diagnostico_previo",
        "diagnostico",

        "descripcion_motivo_consulta",
        "motivo_consulta",
        "informacion_personal_familiar",
        "informacion_academica",
        "aspectos_relevantes"
    ],


    /* ================= FICHA UNICA ================= */

    [COD_FICHA_UNICA]: [
        "ideacion_suicida",
        "conducta_suicida",
        "intento_suicida",

        "deseo_muerte",
        "deseo_danarse",
        "plan_suicida",
        "trataste_suicidarte",

        "descripcion_problematica",
        "motivo_consulta",
        "resumen_procedimiento",
        "observacion_recomendaciones"
    ]
};

export const generarEstadoInicial = (tipo) => {
    const estado = {};

    // Campos de aceptación legal
    estado.acepta_proteccion_datos = { valor: false, error: "" };

    // Generales
    CAMPOS_GENERALES.forEach(campo => {
        estado[campo] = { valor: "" };
    });

    // Específicos
    (CAMPOS_ESPECIFICOS[tipo] || []).forEach(campo => {
        estado[campo] = { valor: "" };
    });

    // Sesiones
    const cantidadSesiones = CONFIG_SESIONES[tipo] || 0;

    if (cantidadSesiones > 0) {
        estado.sesiones = generarSesiones(cantidadSesiones);
    }

    // Campos de responsable y TP para firma
    estado.responsable_atencion = { valor: "", error: "" };
    estado.tp_responsable = { valor: "", error: "" };

    return estado;
};


/* =====================================================
   VALIDACIONES DECLARATIVAS POR FICHA Y PASO
===================================================== */

export const VALIDACIONES_FICHA = {
    // PASO 1: INFORMACIÓN LEGAL - COMÚN PARA TODAS LAS FICHAS
    legal: {
        required: [],  // No validar campos en paso legal aquí
    },

    // PASO 2: INFORMACIÓN GENERAL - COMÚN PARA TODAS LAS FICHAS
    general: {
        required: [
            { key: 'programa', label: 'Programa' },
            { key: 'semestre', label: 'Semestre' },
            { key: 'fecha_nacimiento', label: 'Fecha de Nacimiento' },
            { key: 'estado_civil', label: 'Estado Civil' },
            { key: 'sexo_biologico', label: 'Sexo biológico' },
            { key: 'identidad_genero', label: 'Identidad de género' },
            { key: 'orientacion_sexual', label: 'Orientación Sexual' },
            { key: 'direccion_actual', label: 'Dirección' },
            { key: 'barrio', label: 'Barrio' },
            { key: 'lugar_procedencia', label: 'Lugar de Procedencia' },
            { key: 'departamento', label: 'Departamento' },
            { key: 'municipio', label: 'Municipio' },
            { key: 'contacto_emergencia', label: 'Contacto de Emergencia' },
            { key: 'celular_contacto_emergencia', label: 'Celular del Contacto de Emergencia' },
            { key: 'parentesco', label: 'Parentesco' },
        ]
    },

    // CRISIS - 2 pasos de formulario específico
    [COD_CRISIS]: {
        // Paso 0: Riesgos y Salud (primer formulario después de general)
        0: {
            required: [
                { key: 'nombre_eps', label: 'Nombre EPS' },
                { key: 'sisben', label: '#Sisbén' },
                { key: 'no_vinculado', label: 'No vinculado' },
                { key: 'grupo_priorizado', label: 'Nombre del grupo priorizado' },
                { key: 'se_auto_reconoce_grupo_priorizado', label: 'Se auto reconoce' },
                { key: 'certificado_grupo_priorizado', label: 'Tiene certificado' },
                { key: 'ideacion_suicida', label: '¿Ha presentado Ideación Suicida?' },
                { key: 'intento_suicida', label: '¿Ha presentado Intento Suicida?' },
                { key: 'conducta_suicida', label: '¿Ha presentado Conducta Suicida?' },
                { key: 'deseo_muerte', label: '¿Deseaste estar muerto?' },
                { key: 'deseo_danarse', label: '¿Quisiste hacerte daño?' },
                { key: 'plan_suicida', label: '¿Pensaste en quitarte la vida?' },
                { key: 'trataste_suicidarte', label: '¿Trataste de quitarte la vida?' },
                { key: 'toma_medicamentos', label: '¿Toma medicamentos actualmente?' },
                { key: 'diagnostico_previo', label: '¿Tiene diagnóstico previo?' },
            ],
            conditionalRequired: [
                {
                    key: 'nombre_medicamentos',
                    label: 'Nombre del medicamento',
                    condition: (data) => data?.toma_medicamentos?.valor === 'SI'
                },
                {
                    key: 'diagnostico',
                    label: 'Diagnóstico',
                    condition: (data) => data?.diagnostico_previo?.valor === 'SI'
                }
            ]
        },
        // Paso 1: Descripción de Crisis
        1: {
            required: [
                { key: 'descripcion_crisis', label: 'Descripción de la Crisis' },
                { key: 'motivo_crisis', label: 'Motivo de la Crisis' },
                { key: 'resumen_procedimiento', label: 'Resumen del Procedimiento Realizado' },
                { key: 'recomendaciones', label: 'Recomendaciones' },
                { key: 'seguimiento_1', label: 'Seguimiento 1' },
                { key: 'seguimiento_2', label: 'Seguimiento 2' },
                { key: 'seguimiento_3', label: 'Seguimiento 3' },
                { key: 'seguimiento_4', label: 'Seguimiento 4' },
                { key: 'nivel_riesgo', label: 'Nivel de Riesgo' },
            ]
        }
    },

    // COMUNICATE - 4 pasos
    [COD_COMUNICATE]: {
        // Paso 0: Antecedentes
        0: {
            required: [
                { key: 'nombre_eps', label: 'Nombre EPS' },
                { key: 'sisben', label: '#Sisbén' },
                { key: 'no_vinculado', label: 'No vinculado' },
                { key: 'grupo_priorizado', label: 'Nombre del grupo priorizado' },
                { key: 'se_auto_reconoce_grupo_priorizado', label: 'Se auto reconoce' },
                { key: 'certificado_grupo_priorizado', label: 'Tiene certificado' },
                { key: 'remitido_por', label: 'Remitido por' },
                { key: 'diagnostico_comunicativo', label: 'Diagnóstico' },
                { key: 'examenes_adjuntos', label: 'Exámenes que adjunta' },
                { key: 'antecedentes_comunicativos_detalle', label: 'Problemas de Habla, Lenguaje, Audición, Lectura o Escritura' },
                { key: 'antecedentes_familiares_comunicativos', label: '¿Algún miembro de su familia ha presentado problemas comunicativos?' },
            ]
        },
        // Paso 1: Socio-Afectivo
        1: {
            required: [
                { key: 'motivo_asesoria_comunicativa', label: 'Motivo de la Asesoría' },
                { key: 'con_quien_vive', label: '¿Con quién vive?' },
                { key: 'ocupacion_familia', label: 'Ocupación de las personas con quién vive' },
                { key: 'info_hermanos', label: 'Número de hermanos y lugar que representa' },
                { key: 'comunicacion_familiar', label: '¿Cómo considera la comunicación familiar?' },
                { key: 'actividades_tiempo_libre', label: '¿Qué actividades realiza en su tiempo libre?' },
            ]
        },
        // Paso 2: Habilidades Habla/Lectura
        2: {
            required: [
                { key: 'personas_entienden_comunicacion', label: '¿La gente le entiende cuando habla?' },
                { key: 'pryeccion_voz_adecuada', label: '¿Al hablar en público proyecta su voz adecuadamente?' },
                { key: 'habla_rapido', label: '¿Habla demasiado rápido?' },
                { key: 'habla_lento', label: '¿Habla demasiado lento?' },
                { key: 'muletillas', label: '¿Usa muletillas al hablar?' },
                { key: 'necesidad_escribir_leer', label: '¿Siente la necesidad de escribir o leer? Describa' },
                { key: 'necesidad_comunicacion', label: '¿Necesita usted constantemente proporcionar información o comunicarse? Describa' },
                { key: 'necesidad_recepcion_informacion', label: '¿Necesita usted constantemente recibir información? Describa' },
            ],
            customValidation: 'habilidades_comunicativas'
        },
        // Paso 3: Desempeño y Sesión
        3: {
            required: [
                { key: 'desempeno_academico', label: 'Desempeño Académico' },
                { key: 'desempeno_academico_influenciado', label: '¿Cree usted que su comunicación ha influido en su desempeño académico? Describa' },
            ],
            customValidation: ['habitos_estudio', 'sesiones']
        }
    },

    [COD_APRENDER]: {
        0: {
            required: [
                { key: 'motivo_consulta_cognitiva', label: 'Descripción del Motivo de Consulta' },
                { key: 'motivo_consulta_cognitiva_especifica', label: 'Motivo Específico de la Consulta' },
                { key: 'informacion_personal_familiar', label: 'Información Personal y Familiar' }
            ]
        },
        1: {
            required: [
                { key: 'nombre_eps', label: 'Nombre EPS' },
                { key: 'sisben', label: '#Sisbén' },
                { key: 'no_vinculado', label: 'No vinculado' },
                { key: 'grupo_priorizado', label: 'Nombre Grupo Priorizado' },
                { key: 'se_auto_reconoce_grupo_priorizado', label: 'Se auto reconoce' },
                { key: 'certificado_grupo_priorizado', label: 'Tiene Certificado' },
                { key: 'problema_salud_especial', label: '¿Tiene algún problema de salud que requiera atención especial?' },
                { key: 'problema_vision', label: '¿Problemas de visión?' },
                { key: 'problema_audicion', label: '¿Problemas de audición?' },
                { key: 'alteracion_sueno', label: '¿Presenta alteraciones de sueño?' },
                { key: 'actualmente_esta_medicado', label: '¿Se encuentra medicado actualmente?' },
                { key: 'antecedentes_neurologicos', label: '¿Antecedentes neurológicos?' },
                { key: 'asistencia_terapia_neuropsicologica', label: '¿Asistió a terapia neuropsicológica?' }
            ],
            conditionalRequired: condicionalesDetalleCognitiva()

        },
        2: {
            required: [
                { key: 'calificacion_desempeno_cognitivo', label: 'Calificación Desempeño Actual' },
                { key: 'asignaturas_modalidad_actual', label: 'Asignaturas cursando / Modalidad' },
                { key: 'influencia_desempeno', label: '¿Qué cree que influye en su desempeño?' },
                { key: 'metodo_estudio_planificacion', label: '¿Qué método de estudio utilizas actualmente?' },
                { key: 'aspectos_revelantes_anotaciones', label: 'Aspectos Relevantes - Anotaciones' }
            ]
        },
        3: {
            required: [],
            customValidation: 'sesiones'
        }
    },

    // SOCIOEMOCIONAL - 3 pasos
    [COD_SOCIOEMOCIONAL]: {
        // Paso 0: Salud y Riesgo
        0: {
            required: [
                { key: 'nombre_eps', label: 'Nombre EPS' },
                { key: 'sisben', label: '#Sisbén' },
                { key: 'no_vinculado', label: 'No vinculado' },
                { key: 'grupo_priorizado', label: 'Nombre del grupo priorizado' },
                { key: 'se_auto_reconoce_grupo_priorizado', label: 'Se auto reconoce' },
                { key: 'certificado_grupo_priorizado', label: 'Tiene certificado' },
                { key: 'ideacion_suicida', label: '¿Ha presentado Ideación Suicida?' },
                { key: 'intento_suicida', label: '¿Ha presentado Intento Suicida?' },
                { key: 'conducta_suicida', label: '¿Ha presentado Conducta Suicida?' },
                { key: 'deseo_muerte', label: '¿Deseaste estar muerto?' },
                { key: 'deseo_danarse', label: '¿Quisiste hacerte daño?' },
                { key: 'plan_suicida', label: '¿Pensaste en quitarte la vida?' },
                { key: 'trataste_suicidarte', label: '¿Trataste de quitarte la vida?' },
                { key: 'toma_medicamentos', label: '¿Toma medicamentos actualmente?' },
                { key: 'diagnostico_previo', label: '¿Tiene diagnóstico previo?' },
            ],
            conditionalRequired: [
                {
                    key: 'nombre_medicamentos',
                    label: 'Nombre del medicamento',
                    condition: (data) => data?.toma_medicamentos?.valor === 'SI'
                },
                {
                    key: 'diagnostico',
                    label: 'Diagnóstico',
                    condition: (data) => data?.diagnostico_previo?.valor === 'SI'
                }
            ]
        },
        // Paso 1: Descripción
        1: {
            required: [
                { key: 'descripcion_motivo_consulta', label: 'Descripción del motivo de la consulta' },
                { key: 'motivo_consulta', label: 'Motivo de la Consulta' },
                { key: 'informacion_personal_familiar', label: 'Información personal y familiar' },
                { key: 'informacion_academica', label: 'Información Académica' },
                { key: 'aspectos_relevantes', label: 'Aspectos relevantes - anotaciones' },
            ]
        },
        // Paso 2: Plan de Manejo
        2: {
            required: [],
            customValidation: 'sesiones'
        }
    },

    // FICHA ÚNICA - 2 pasos
    [COD_FICHA_UNICA]: {
        // Paso 0: Riesgos y Salud
        0: {
            required: [
                { key: 'nombre_eps', label: 'Nombre EPS' },
                { key: 'sisben', label: '#Sisbén' },
                { key: 'no_vinculado', label: 'No vinculado' },
                { key: 'grupo_priorizado', label: 'Nombre del grupo priorizado' },
                { key: 'se_auto_reconoce_grupo_priorizado', label: 'Se auto Reconoce' },
                { key: 'certificado_grupo_priorizado', label: 'Tiene Certificado' },
                { key: 'ideacion_suicida', label: '¿Ha presentado Ideación Suicida?' },
                { key: 'intento_suicida', label: '¿Ha presentado Intento Suicida?' },
                { key: 'conducta_suicida', label: '¿Ha presentado Conducta Suicida?' },
                { key: 'deseo_muerte', label: '¿Deseaste estar muerto?' },
                { key: 'deseo_danarse', label: '¿Quisiste hacerte daño?' },
                { key: 'plan_suicida', label: '¿Pensaste en quitarte la vida?' },
                { key: 'trataste_suicidarte', label: '¿Trataste de quitarte la vida?' },
            ]
        },
        // Paso 1: Descripción
        1: {
            required: [
                { key: 'descripcion_problematica', label: 'Descripción de la Problemática' },
                { key: 'motivo_consulta', label: 'Motivo de Consulta' },
                { key: 'resumen_procedimiento', label: 'Resumen del Procedimiento' },
                { key: 'observacion_recomendaciones', label: 'Observaciones y Recomendaciones' },
            ]
        }
    },

    // PASO FIRMA
    firma: {
        required: [],  
    }
};

const KEYS_ERROR_SIN_INPUT = new Set([
    'habilidades_comunicativas',
    'habitos_estudio',
]);

const DICCIONARIO_POR_FICHA = {
    [COD_CRISIS]: ['general', 'crisis'],
    [COD_COMUNICATE]: ['general', 'comunicativa'],
    [COD_APRENDER]: ['general', 'cognitiva'],
    [COD_SOCIOEMOCIONAL]: ['general', 'psicologia'],
    [COD_FICHA_UNICA]: ['general', 'unica_sesion'],
};

const recolectarNombresDiccionario = (secciones = []) => {
    const nombres = new Set();
    secciones.forEach((seccion) => {
        Object.values(FORM_DICTIONARY.fichas[seccion] || {}).forEach((campo) => {
            if (campo?.name) nombres.add(campo.name);
            if (campo?.detalle) nombres.add(campo.detalle);
        });
    });
    return nombres;
};

export const obtenerDesalineacionesValidacionFichas = () => {
    const desalineaciones = [];
    Object.entries(DICCIONARIO_POR_FICHA).forEach(([tipo, secciones]) => {
        const nombresUi = recolectarNombresDiccionario(secciones);
        const camposEstado = new Set([
            ...CAMPOS_GENERALES,
            ...(CAMPOS_ESPECIFICOS[tipo] || []),
        ]);
        const pasos = VALIDACIONES_FICHA[tipo] || {};
        Object.values(pasos).forEach((paso) => {
            [...(paso.required || []), ...(paso.conditionalRequired || [])].forEach(({ key }) => {
                if (!key || KEYS_ERROR_SIN_INPUT.has(key)) return;
                if (!nombresUi.has(key)) {
                    desalineaciones.push({ tipo, key, motivo: 'no existe en formFields (name/detalle)' });
                }
                if (!camposEstado.has(key)) {
                    desalineaciones.push({ tipo, key, motivo: 'no existe en CAMPOS_GENERALES/ESPECIFICOS' });
                }
            });
        });
    });
    return desalineaciones;
};